export default function (http) {
    return {

        /*************************产品分类接口开始***********************/
        /**
         * 查询字典列表
         * @param data
         * @return {*}
         */
        queryDictList(data) {
            return http.json({
                url: '/erp/pro/category/query',
                data
            })
        },


        queryRepairCategoryDictList(){
            return http.json({
                url: '/erp/pro/category/queryByCodeEqRepairCategory?code=repairCategory',
            })
        },
        /**
         * 获取字典详情
         * @param data
         * @return {*}
         */
        getDictInfo(data) {
            return http({
                url: `/erp/pro/category/get?id=${data.id}`,
                method: 'post'
            })
        },


        /**
         * 保存字典信息
         * @param data
         * @return {*}
         */
        saveDictInfo(data) {
            return http.json({
                url: '/erp/pro/category/save',
                data
            })
        },

        /**
         * 删除字典
         * @param data
         * @return {*}
         */
        removeDict(data) {
            return http.json({
                url: '/erp/pro/category/delete',
                data
            })
        },

        /** ***********************产品分类接口结束***********************/




        /*************************产品管理接口开始***********************/

        queryByPage (data){
            return http.json({
                url: '/erp/pro/base/query',
                data
            });
        },
        getInfo (data){
            return http.json({
                url: `/erp/pro/base/get?id=${data.id}`,
                data
            })
        },
        saveInfo (data){
            return http.json({
                url: `/erp/pro/base/save`,
                data
            })
        },
        delete (data){
            return http.json({
                url: `/erp/pro/base/delete`,
                data
            })
        },
        /** ***********************产品管理接口结束***********************/

        queryByCategory (data){
            return http.json({
                url: `/erp/pro/base/queryAll`,
                data
            })
        },



        queryAll(data){
            return http.json({
                url: `/erp/pro/base/queryAll`,
                data
            })
        },





    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/pro.js